import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=1d52fd55&"
import script from "./prices.vue?vue&type=script&lang=ts&"
export * from "./prices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "prices.vue"
export default component.exports